<template>

<Layout>
  <div class="section content is-size-7">
    <p>
      Czy masz pytania dotyczące subskrypcji? Chętnie pomożemy!<br>
      
        Telefon: <a href="tel:221253450">221253450</a><br>
        E-Mail: <a href="mailto:778mobile.pl@silverlines.info">778mobile.pl@silverlines.info</a><br>
    </p>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/PL/Help.vue